import type { ShadowScale } from './types';

export const BRAVEMOVE_SHADOW: ShadowScale = {
  none: 'none',
  sm: '0 1px 0 rgba(0,0,0,.04)',
  md: '0 4px 12px -4px rgba(0,0,0,.10)',
  lg: '0 16px 40px -20px rgba(0,0,0,.20)',
  glow: (color: string) => `0 0 24px -4px ${color}`,
};
